import {Fragment} from 'react';

import {BUSINESS_LOCATION_TYPE, BusinessLocationService as Service} from './BusinessLocationService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import { ROLE } from '../../../Constant';
import {useTranslation} from '../../../shared/language';

const BUSINESS_LOCATION_TYPE_OPTIONS = [
  {
    value: BUSINESS_LOCATION_TYPE.HOUSEHOLD_OR_BRANCH,
    translationKey: 'catalog.businessLocationTypeHouseholdOrBranch',
  },
  {
    value: BUSINESS_LOCATION_TYPE.PETROL_BUSINESS,
    translationKey: 'catalog.businessLocationTypePetrolBusiness',
  },
];

const getBusinessLocationCodeMaxLength = (item: any): number =>
  Number(item?.businessType) === BUSINESS_LOCATION_TYPE.HOUSEHOLD_OR_BRANCH ? 5 : 14;

// Mã đã nhập có thể dài hơn giới hạn mới khi người dùng đổi loại hình, nên cần kiểm tra lại theo businessType hiện tại.
const validateBusinessLocationCode = (value: any, item: any): string => {
  if (`${value || ''}`.trim().length <= getBusinessLocationCodeMaxLength(item)) {
    return '';
  }

  return Number(item?.businessType) === BUSINESS_LOCATION_TYPE.HOUSEHOLD_OR_BRANCH
    ? 'businessLocationCodeLengthHouseholdOrBranch'
    : 'businessLocationCodeLengthPetrolBusiness';
};

/** Hiển thị danh mục ĐĐKD và các thao tác quản lý theo FR-01. */
export const List = () => {

  const {t} = useTranslation();
  const header = t('catalog.businessLocation');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      // Backend dùng businessType cho cả dữ liệu địa điểm và query filter nên UI giữ cùng một field.
      {field: 'businessType', header: t('catalog.businessLocationType'), width: 250, matchMode: 'equals', filterType: 'dropdown', filterOptions: BUSINESS_LOCATION_TYPE_OPTIONS, dataType: 'fromFilterOptions', dataOptions: BUSINESS_LOCATION_TYPE_OPTIONS},
      {field: 'code', header: t('catalog.businessLocationCode'), width: 250, matchMode: 'contains'},
      {field: 'name', header: t('catalog.businessLocationName'), minWidth: 250, matchMode: 'contains'},
      {field: 'address', header: t('catalog.businessLocationAddress'), minWidth: 250, matchMode: 'contains'},
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '70rem',
    fields: [
      {field: 'businessType', header: t('catalog.businessLocationType'), required: true, revalidateFields: ['code'], revalidateFieldsWithoutRequired: ['code'], type: 'Dropdown', DropdownProps: {options: BUSINESS_LOCATION_TYPE_OPTIONS}, className: 'md:col-12'},
      {field: 'code', header: t('catalog.businessLocationCode'), required: true, uppercase: true, revalidateFields: ['businessType'], validate: validateBusinessLocationCode, InputTextProps: {maxLength: getBusinessLocationCodeMaxLength, validator: 'alphanumDashUnderscore'}, className: 'md:col-6'},
      {field: 'name', header: t('catalog.businessLocationName'), required: true,InputTextProps: {maxLength: 400}, className: 'md:col-6'},
      {field: 'address', header: t('catalog.businessLocationAddress'), required: true,InputTextProps: {maxLength: 400}, className: 'md:col-12'},
    ],
    createItem: (item) => {
      // BE cần nhận active=true vì trạng thái này không còn được nhập trên form và địa điểm mới phải dùng ngay ở FR-02.
      return Service.create({...item, active: true});
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    createRole: ROLE.CATEGORY_UNIT_CREATE, 
    editRole: ROLE.CATEGORY_UNIT_EDIT, 
    cloneRole: ROLE.CATEGORY_UNIT_COPY, 
    deleteRole: ROLE.CATEGORY_UNIT_DELETE, 
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
